/**
 * 국내 입출금 가능 금융기관 목록.
 * 시중·지방·특수·인터넷전문은행 + 상호금융 + 저축은행을 포함한다.
 * (판매 정산·구매자 환불 계좌 select 공통)
 */
export const MALL_BANKS = [
  /* 시중은행 */
  '국민은행',
  '신한은행',
  '우리은행',
  '하나은행',
  'SC제일은행',
  '한국씨티은행',
  'iM뱅크',
  '대구은행',
  /* 지방은행 */
  '부산은행',
  '경남은행',
  '광주은행',
  '전북은행',
  '제주은행',
  /* 특수은행 */
  '산업은행',
  '기업은행',
  '농협은행',
  '수협은행',
  '수출입은행',
  /* 인터넷전문은행 */
  '카카오뱅크',
  '케이뱅크',
  '토스뱅크',
  /* 상호금융·우체국 */
  '단위농협',
  '지역농협',
  '수협',
  '신협',
  '새마을금고',
  '우체국',
  /* 저축은행 */
  'SBI저축은행',
  'OK저축은행',
  '웰컴저축은행',
  '한국투자저축은행',
  '페퍼저축은행',
  '유진저축은행',
  '애큐온저축은행',
  '다올저축은행',
  '상상인저축은행',
  '상상인플러스저축은행',
  '키움저축은행',
  '키움YES저축은행',
  '대신저축은행',
  'DB저축은행',
  '하나저축은행',
  '신한저축은행',
  'KB저축은행',
  '우리금융저축은행',
  'NH저축은행',
  'IBK저축은행',
  'BNK저축은행',
  'JT저축은행',
  'JT친애저축은행',
  'OSB저축은행',
  '모아저축은행',
  '스마트저축은행',
  '민국저축은행',
  '푸른저축은행',
  '금화저축은행',
  '인성저축은행',
  '조은저축은행',
  '더케이저축은행',
  '예가람저축은행',
  '유안타저축은행',
  '고려저축은행',
  '동원제일저축은행',
  '삼정저축은행',
  '진주저축은행',
  '흥국저축은행',
  '오투저축은행',
  '국제저축은행',
  '드림저축은행',
  '라온저축은행',
  '머스트삼일저축은행',
  '세람저축은행',
  '센트럴저축은행',
  '스타저축은행',
  '안국저축은행',
  '안양저축은행',
  '영진저축은행',
  '융창저축은행',
  '인저축은행',
  '조흥저축은행',
  '청주저축은행',
  '평택저축은행',
  '한성저축은행',
  '한화저축은행',
  '엠에스저축은행',
  '스카이저축은행',
  '솔브레인저축은행',
  '남양저축은행',
  '대아상호저축은행',
  '대원저축은행',
  '대한저축은행',
  '더블저축은행',
  '동양저축은행',
  '동화저축은행',
  '부림저축은행',
  '삼호저축은행',
  '서울저축은행',
  '아산저축은행',
  '에스앤티저축은행',
  '오성저축은행',
  '우리저축은행',
  '유니온저축은행',
  '인천저축은행',
  '조흥제일저축은행',
  '참저축은행',
  '친애저축은행',
  '토마토저축은행',
] as const

export type MallBank = (typeof MALL_BANKS)[number]

/** 가입·프로필 환불 계좌용 별칭 */
export const MEMBER_REFUND_BANKS = MALL_BANKS

export function isMallBank(value: string): value is MallBank {
  return (MALL_BANKS as readonly string[]).includes(value)
}
